import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
const ModalOverduePayment = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          maxWidth: "90%",
          overflowY: "hidden",
          overflowX: "wrap",
          maxHeight: "80vh",
          padding: 0,
        }}
        className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
      >
        <div className="px-8 py-4">
          <p className="text-[18px] mb-4 text-center font-semibold">
            Penunggakan Bayaran
          </p>
          <p className="mb-4 text-center">
            Anda masih memiliki tagihan yang belum dibayar. Mohon lakukan
            pembayaran
          </p>

          <button
            type="button"
            className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2.5 text-[14px] disabled:bg-gray-300 lg:mb-2"
            onClick={() => navigate(`/online-billing-pbf`)}
          >
            Bayar Sekarang
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalOverduePayment;
